module.exports = __webpack_public_path__ + "fonts/2cd55546-ec00-4af9-aeca-4a3cd186da53.457e94a.woff2";


//////////////////
// WEBPACK FOOTER
// ./static/fonts/AvenirNext/2cd55546-ec00-4af9-aeca-4a3cd186da53.woff2
// module id = 155
// module chunks = 245 246